import PropTypes from "prop-types";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';

function CustomSnackbar({ color, icon, title, dateTime, content, close, bgWhite, ...rest }) {

  const titleColor = "white";
  const dateTimeColor = "white";
  const dividerColor = "white";

  return (
    <Snackbar
      TransitionComponent={Fade}
      autoHideDuration={5000}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      {...rest}
      action={
        <IconButton size="small" aria-label="close" color="inherit" onClick={close}>
          <Icon fontSize="small">close</Icon>
        </IconButton>
      }
    >
      <Box
        sx={{
          backgroundColor: color === "success" ? "#5BB35F" : color === "error" ? "#EC4C48" : "#5BB35F",
          minWidth: "21.875rem",
          maxWidth: "100%",
          borderRadius: "8px",
          padding: 1,
          boxShadow: 2,
        }}
      >

        <Box display="flex" justifyContent="space-between" alignItems="center" padding={1.5}>
          <Box display="flex" alignItems="center">
            {/* <Icon>{icon}</Icon> */}
            <Typography variant="button" fontWeight={700} color="white" fontFamily="Nunito Sans" >
              {title}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <Typography variant="caption" color={dateTimeColor}>
              {dateTime}
            </Typography>

          </Box>
          <Box>
            <CloseIcon sx={{ marginTop: "-25px", color: "white", cursor: "pointer" }} onClick={close} />
          </Box>
        </Box>

        <Divider light={dividerColor} />
        <Box padding={1.5} sx={{ fontSize: "14px", color: "white", fontWeight: 700, fontFamily: "Nunito Sans" }}>
          {content}
        </Box>
      </Box>
    </Snackbar>
  );
}

CustomSnackbar.defaultProps = {
  bgWhite: false,
  color: "info",
};

CustomSnackbar.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  dateTime: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  close: PropTypes.func.isRequired,
  bgWhite: PropTypes.bool,
};

export default CustomSnackbar;
